<template>
  <router-view></router-view>
</template>

<script>
import NotificationSample from "src/pages/Dashboard/Components/NotificationSample";
import api from "./util/api";

export default {
  created() {
    api.findToken();
    console.log("auth", this.$store.state.auth.authenticated);
    // if (!this.$store.state.auth.authenticated) {
    //   this.$router.replace({ name: "Login" });
    // }
  }
};
</script>
